<article role="article" class="ap-promo-card">
  <div class="ap-promo-card__content">
    <div class="ap-promo-card__badge">Protección recomendada para ti</div>

    <div class="icon-content">
      <img src="./assets/img/svg/escudo-check.svg" width="48" height="48" alt="Ícono de accidente" />
    </div>
    <h2 class="ap-promo-card__title">Refuerza tu protección ante accidentes</h2>
    <p class="ap-promo-card__description">
      Completa tu seguro con el <b> Seguro de Accidentes Personales</b>, que te protege a ti con cobertura inmediata ante imprevistos del
      día a día.
    </p>
    <ul class="ap-promo-card__benefits">
      <li class="ap-promo-card__benefit">Asistencia médica inmediata por accidentes.</li>
      <li class="ap-promo-card__benefit">Cobertura 24/7 en cualquier lugar</li>
      <li class="ap-promo-card__benefit">Hasta $50 millones en indemnización</li>
    </ul>
    <span class="ap-promo-card__disclaimer">Este seguro se contrata de forma independiente y tiene un pago adicional.</span>
    <a id="btn-promomotos-whatsapp" data-seo="btn-promomotos-whatsapp" href="{{ whatsapp_link }}" target="_blank" class="btn-promo-card"
      >Cotizar con un asesor</a
    >
  </div>
</article>
